/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {reportPresence} from '../api'

export const useMutationReportPresence = createReactQueryMutationHook('reportPresence', reportPresence)
